import {Button} from '@material-ui/core';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Loading from 'Shared/components/Loading';
import Modal from 'Shared/components/Modal';
import {Scope} from 'Shared/constants/Scope';
import {extractApplicationIdsFromScope} from 'Shared/utilities/applicationId';
import {UserDto} from 'Users/api';
import 'Users/components/UserAdministration/DeleteUserConfirmationModal.sass';
import * as UserActions from 'Users/ducks/userAdministration';
import {deleteUser} from 'Users/ducks/userAdministration';
import {Application} from 'Users/models/Application';
import {LineOfBusiness} from 'Users/models/LineOfBusiness';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';

type DeleteUserConfirmationModalProps = {
  user: UserActions.UserType | UserDto;
  onClose: () => void;
  open: boolean;
};

const DeleteUserConfirmationModal = (props: DeleteUserConfirmationModalProps) => {
  const {onClose, open, user} = props;
  const [isDeleting, setIsDeleting] = useState(false);
  const dispatch = useDispatch();

  const scopes = useSelector(selectUserScopes);
  const applicationIds = extractApplicationIdsFromScope(scopes, Scope.DeleteUser);
  const applicationNames = applicationIds?.map(a => Application[a])?.join(', ') || '';

  // If current user have access to delete the entire user then it will be a full deletion
  const isFullDeletion =
    scopes.find(scope => scope.toString() === Scope.DeleteUser + '|*') ||
    (user.linesOfBusiness?.every(lob => {
      switch (lob.id) {
        case LineOfBusiness.Agent:
          return applicationIds.includes(Application.Agent);
        default:
          return false;
      }
    }) ??
      true);

  return (
    <Modal
      className="delete-user-confirmation-modal"
      title={`Delete ${user.userName}?`}
      onClose={onClose}
      open={open}
      disableBackdropClick
    >
      {isDeleting ? (
        <Loading />
      ) : (
        <>
          <div className="delete-user-confirmation-modal__body">
            <h2 className="delete-user-confirmation-modal__title">{`Are You Sure You Want To ${
              isFullDeletion ? 'Delete' : `Remove ${applicationNames} Access for`
            } ${user.userName}?`}</h2>
            <p>
              {isFullDeletion
                ? 'Deleting this user will permanently remove their account and disable their ability to login to MyAccess.'
                : `Deleting this user will permanently remove their access to ${applicationNames}.`}
            </p>
          </div>
          <div className="delete-user-confirmation-modal__actions">
            <Button className="actions__cancel-button" onClick={onClose} variant="contained">
              Cancel
            </Button>
            <Button
              className="actions__delete-button"
              onClick={() => {
                setIsDeleting(true);
                dispatch(deleteUser(user.id!, onClose));
              }}
              color="primary"
              variant="contained"
            >
              Confirm Delete
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default DeleteUserConfirmationModal;
